<template>
  <Dialog
      v-model="show"
      :title="$t('Cambiar contraseña')"
  >
    <!--    Contenido del dialogo-->
    <template v-slot:content>
      <ValidationObserver ref="form">
        <v-row>
          <v-col>
            <ValidationProvider rules="required" :name="$t('Contraseña').toLowerCase()"
                                v-slot="{ errors, classes }">
              <v-text-field
                  v-model="password"
                  :label="$t('Contraseña')"
                  :type="show_password?'text':'password'"
                  outlined dense hide-details
                  :class="classes"
              >
                <template v-slot:append-outer>
                  <v-btn icon @click="show_password = !show_password">
                    <v-icon v-if="!show_password">mdi-eye</v-icon>
                    <v-icon v-else>mdi-eye-off</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <span class="error--text pl-1">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </template>
    <template v-slot:right-action>
      <v-btn @click="send" small class="primary">
        <v-icon small>mdi-send</v-icon>
        {{ $t("Enviar") }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';

export default {
  name: "FormPasswordClienteOnline",

  data: () => ({
    password: "",
    show_password: false
  }),


  methods: {
    async send() {
      const data = {
        id: this.item.id,
        password: this.password
      }

      const form_valid = await this.$refs.form.validate()

      if (form_valid) {
        try {
          await this.$store.dispatch('cliente/update_password_cliente_online', data)
          this.$emit('on_password_changed')
          return this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        } catch (e) {
          return this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    }
  },

  props: ['value', 'item'],

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  components: {
    ValidationObserver,
    ValidationProvider
  },


}
</script>

<style scoped>

</style>